import { render, staticRenderFns } from "./BZAgreement.vue?vue&type=template&id=70b7f800&scoped=true&"
var script = {}
import style0 from "./BZAgreement.vue?vue&type=style&index=0&id=70b7f800&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b7f800",
  null
  
)

export default component.exports